import React from 'react';
import { connect } from 'react-redux';
import FileUploader from '../components/FileUploader';
import NewCollectiveResults from '../components/NewCollectiveResults';
import {
  updateCollectiveResults,
  mergeRequestDialog,
  requestLocationChange,
  requestImport,
  requestImportError
} from '../actions';
import { camelizeKeys } from 'humps';
import Config from '../Config';
import RaisedButton from 'material-ui/RaisedButton';
import { Card, CardActions, CardText, CardTitle, CardMedia } from 'material-ui/Card';
import ActionCheckCircle from 'material-ui/svg-icons/action/check-circle';
import MdCheckCircle from 'react-icons/lib/md/check-circle';
import MergeDialog from '../components/MergeDialog';

function Importer(props) {
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px' }}>
      <FileUploader
        scope="influencers"
        onComplete={props.onUploadComplete}
        onUpload={props.onUpload}
        onError={props.onUploadError}
      >
        <Card style={{
          marginTop: 20,
          backgroundColor: 'white',
        }}>
          <CardTitle
            title="Upload a list of contacts in Excel or CSV format using the provided template."
            subtitle="Drag a file here or click upload button."
          />
          <CardActions>
            <RaisedButton
              label="Upload"
              primary={true}
            />
          </CardActions>
        </Card>
      </FileUploader>
      <RaisedButton
        style={{ marginTop: 10 }}
        label="Download Template"
        href={`${Config.apiEndpoint}/influencers/download_import_template`}
      />
      {props.completed &&
        <Card style={{
          marginTop: 10,
          backgroundColor: 'white',
        }}>
          <CardText style={{ textAlign: 'center' }}>
            <MdCheckCircle style={{ width: 100, height: 100 }} fill="green" />
          </CardText>
          <CardTitle
            style={{ textAlign: 'center' }}
            title="Import Complete!"
          />
        </Card>
      }
      {props.result.size > 0 &&
        <NewCollectiveResults
          collectives={props.collectives}
          results={props.result}
          onMergeRequest={props.onMergeRequest}
          handleEdit={props.handleEdit}
        />
      }
      <MergeDialog
        name={props.mergeId ? props.collectives.get('items').get(props.mergeId.toString()).get('name') : ''}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    collectives: state.get('collectives'),
    result: state.get('importer').get('result'),
    completed: state.get('importer').get('completed'),
    mergeDialog: state.get('importer').get('mergeId') !== 0,
    mergeId: state.get('importer').get('mergeId'),
    mergeIntoId: state.get('importer').get('mergeIntoId'),
    isFetching: state.get('collectives').get('isFetching') && state.get('importer').get('isFetching'),
  };
}

function mapDispatchToProps(dispatch) {
  return {

    onUpload: function () {
      dispatch(requestImport());
    },

    onUploadComplete: function (response) {
      dispatch(
        updateCollectiveResults(camelizeKeys(response))
      );
    },

    onUploadError: function (response) {
      dispatch(requestImportError(response));
    },

    onMergeRequest: function (id) {
      dispatch(mergeRequestDialog(id));
    },

    handleEdit: function (id) {
      dispatch(requestLocationChange('editCollectiveImport', { id: id }));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Importer);



/** WEBPACK FOOTER **
 ** ./containers/Importer.js
 **/